import coreAPIInstance from "./coreApiInstance";

export const newsAPIs = {
  getNewsChannels: ({ payload }) =>
    coreAPIInstance.get(`/api/v1/channels`, {
      params: {
        entityId: payload.entityId,
        page: payload.page,
        pageSize: payload.limit,
        search: payload.search,
      },
      headers: {
        entityId: payload.entityId,
      },
    }),
  getNewsChannelById: ({ channelId, payload }) =>
    coreAPIInstance.get(`/api/v1/channels/${channelId}`, {
      headers: {
        entityId: payload.entityId,
      },
    }),
  createNewNewsChannel: ({ payload }) => coreAPIInstance.post(`/api/v1/channels`, payload),
  deleteNewsChannel: ({ channelId, payload }) =>
    coreAPIInstance.delete(`/api/v1/channels/${channelId}`, {
      headers: {
        entityId: payload.entityId,
      },
    }),
  updateNewsChannel: ({ channelId, payload }) => coreAPIInstance.put(`/api/v1/channels/${channelId}`, payload),
  getNewsShows: ({ payload }) =>
    coreAPIInstance.get(`/api/v1/shows`, {
      params: {
        entityId: payload.entityId,
        page: payload.page,
        pageSize: payload.limit,
        search: payload.search,
      },
      headers: {
        entityId: payload.entityId,
      },
    }),
  getNewsShowById: ({ showId, payload }) =>
    coreAPIInstance.get(`/api/v1/shows/${showId}`, {
      headers: {
        entityId: payload.entityId,
      },
    }),
  createNewsShow: ({ payload }) => coreAPIInstance.post(`/api/v1/shows`, payload),
  deleteNewsShow: ({ showId, payload }) =>
    coreAPIInstance.delete(`/api/v1/shows/${showId}`, {
      headers: {
        entityId: payload.entityId,
      },
    }),
  updateNewsShow: ({ showId, payload }) => coreAPIInstance.put(`/api/v1/shows/${showId}`, payload),
};
